/* eslint react/destructuring-assignment: 0 */
import React, { useEffect, useRef } from "react";

import { scrollIntoViewWithObserver } from "utils";

import { NavigationSplitViewTileProps } from "models";

import { Flex, Icon } from "components";

export const NavigationSplitViewTile = ({
  tile,
  selectedGroupIndex,
  selectedSubGroupIndex,
  selectedTileIndex,
  groupIndex,
  subGroupIndex,
  tileIndex,
  onTileClicked,
  dataTestId,
}: NavigationSplitViewTileProps) => {
  const tileRef = useRef<HTMLDivElement | null>(null);

  const isSameGroup = selectedGroupIndex === groupIndex;
  const isSameSubGroup = selectedSubGroupIndex === subGroupIndex;
  const isSameTile = selectedTileIndex === tileIndex;
  const isSelected = isSameGroup && isSameSubGroup && isSameTile;

  useEffect(() => {
    if (isSelected) scrollIntoViewWithObserver(tileRef);
  }, [isSelected]);

  return tile.show ? (
    <Flex
      ref={tileRef}
      className={`navigation-split-view-tile ${isSelected && "selected"}`}
      data-testid={`${dataTestId}-${tileIndex}`}
      align="center"
      justify="space-between"
      onClick={() => {
        scrollIntoViewWithObserver(tileRef);
        onTileClicked({ groupIndex: groupIndex, subGroupIndex: subGroupIndex, tileIndex: tileIndex });
      }}
    >
      <p className="title" data-testid={`${dataTestId}-${tileIndex}-title`}>
        {tile.title}
      </p>
      <Flex className="value-icon-wrapper" gap="1rem" align="center" justify="space-between">
        <p className="value" data-testid={`${dataTestId}-${tileIndex}-value`}>
          {tile.value}
        </p>
        <Icon dataTestId={`${dataTestId}-${tileIndex}-icon`} iconName="tabler/chevron-right" />
      </Flex>
    </Flex>
  ) : null;
};
